import React from 'react';
import { Box, Button, Container, Divider, Typography } from '@mui/material';
import '../../pages/pageStyles/LandingPage.css';
import NewsletterSubForm from '../newsletter/NewsletterSubForm';

const NewsletterSubSection = () => (
  <>
    <Container maxWidth="sm" sx={{ textAlign: 'center', paddingTop: '2rem' }} id="newsletter">
      <Typography variant="h4" fontWeight={700} gutterBottom>
        Stay in the Loop
      </Typography>
      <Typography variant="body1" sx={{ fontSize: '1.1rem', color: 'text.secondary', mb: 3 }}>
        Follow our blog on Substack for updates on dyslexia research, new features, and
        education insights — delivered straight to your inbox.
      </Typography>
      <Button
        variant="contained"
        href="https://dyslexico.substack.com"
        target="_blank"
        rel="noopener noreferrer"
        size="large"
        sx={{
          backgroundColor: '#ec4755',
          fontWeight: 600,
          px: 4,
          textTransform: 'unset',
          '&:hover': { backgroundColor: '#a12c34' },
        }}
      >
        Subscribe on Substack
      </Button>
      <Box sx={{ my: 4 }}>
        <Divider>
          <Typography variant="caption" color="text.secondary" sx={{ px: 1 }}>
            or join our mailing list
          </Typography>
        </Divider>
      </Box>
      <NewsletterSubForm />
    </Container>
  </>
);

export default NewsletterSubSection;